<template>
	<div class="text-gray-700 focus-within:text-orange-500">
		<div class="flex justify-between flex-wrap">
			<label class="flex font-medium" :for="inputId" v-if="!noLabel">
				{{ __(label) }}

				<ui-tooltip
					v-if="tooltipText"
					class="flex text-green-400 whitespace-normal"
					:icon-stroke-width="2"
					icon-class="ml-1 w-4 h-4"
					:text="__(tooltipText)"
				>
					<ui-icon
						class="sm:mr-2 flex-shrink-0 h-6 w-6 md:h-5 md:w-5"
						name="help-circle"
						stroke-width="2"
					/>
				</ui-tooltip>
			</label>
			<span class="text-gray-500" v-if="!noLabel && !required && !markInvalid && !inValid">optional</span>
		</div>
		<div class="mt-1 relative">
			<select
				:disabled="disabled"
				:id="inputId"
				@focus="onFocus"
				:class="[
					'text-gray-900 shadow-sm focus:ring-orange-500 focus:border-orange-500 block w-full border-gray-300 rounded-md truncate',
					markInvalid
						? 'text-red-600 border-red-600 bg-red-100 shadow-sm focus:text-gray-900'
						: '',
					inValid
						? 'text-red-600 border-red-600 bg-red-100 shadow-sm focus:text-gray-900'
						: '',
						disabled ? 'bg-gray-100' : ''
				]"
				v-model="val"
			>
				<option v-if="placeholder && (!required || !val)"></option>
				<option v-for="o in options" :key="o.id" :value="o.id">
					{{ __(o.name || o.label) }}
				</option>
			</select>
		</div>
		<span class="text-red-600" v-if="inValid">{{ firstValidationError }}</span>
		<span class="text-red-600" v-else-if="markInvalid">{{ validationMessage }}</span>
	</div>
</template>

<script>
import UiInputGroup from "./InputGroup.vue";
export default {
	mixins: [UiInputGroup],
	props: {
		type: {
			type: String,
			default: "select",
		},
		options: {
			type: Array,
			required: true,
		},
		noLabel: {
			type: Boolean,
			default: false,
		},
		placeholder: {
			type: Boolean,
			default: true,
		},
		disabled: {
			type: Boolean,
			default: false,
		}
	},
	data() {
		return {
			validationErrors: null,
		};
	},
	mounted() {
		this.$bus.$off("form:invalid", this.setValidationErrors);
		this.$bus.$on("form:invalid", this.setValidationErrors);
	},
	computed: {
		inValid() {
			return this.validationErrors?.length > 0;
		},
		firstValidationError() {
			return this.validationErrors[0] ?? "";
		},
	},
	methods: {
		setValidationErrors(event) {
			this.validationErrors = event[this.field];
		},
	},
	beforeDestroy() {
		this.$bus.$off("form:invalid", this.setValidationErrors);
	},
};
</script>
